var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "or-popover",
    {
      attrs: {
        "data-component": "base-search-date-time-popup",
        placement: "bottom-start",
        trigger: _vm.trigger,
        "is-open": _vm.isOpen,
      },
    },
    [
      _c("base-date-time-range-picker", {
        staticClass: "base-date-time-range-picker",
        attrs: {
          datetime: _vm.value,
          "min-date-filter": _vm.minDateFilter,
          "max-date-filter": _vm.maxDateFilter,
          "initial-range-direction": "backward",
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
          "datetime-change": _vm.onDateTimeConfirm,
          cancel: _vm.onDatePickerClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }